// extracted by mini-css-extract-plugin
module.exports = {"root":"ValueInput__root___1rDAN","block":"ValueInput__block___1AZmy","control":"ValueInput__control____rwvC"};